import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../shared/interface/user-permissions";
import {FormRow} from "../../../shared/interface/form-row";
import {AuthService} from "../../../shared/services/auth.service";
import {FormRowItem} from "../../../shared/interface/form-row-item";
import {OfwcaMeeting} from "../../../shared/interface/ofwca-meeting";
import {MatSnackBar} from "@angular/material/snack-bar";


@Component({
  selector: 'app-dynamic-form-view',
  templateUrl: './dynamic-form-view.component.html',
  styleUrls: ['./dynamic-form-view.component.scss']
})
export class DynamicFormViewComponent implements OnInit {
  @Input() formRow: FormRow;
  @Output() modifyClicked = new EventEmitter<any>();
  userPermissions: ReplaySubject<UserPermissions>;
  array: string [];
  constructor(
    private auth: AuthService,
    private snack: MatSnackBar,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.getValuesArray();
  }
  modify(): void {
    this.modifyClicked.emit();
  }
  getValuesArray(): void {
    this.formRow.data.forEach((formItem: FormRowItem) => {
      if ((formItem.type === 'array' || formItem.type === 'header') && formItem.value !== null) {
        formItem.splitValues = formItem.value.split(',');
      } else {
        formItem.splitValues = [];
      }
    });
  }

  copyMessage(val: string): void{
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.snack.open('Skopiowano do schowka', '', {duration: 2000});
  }
}
